const range = (start, stop, step) => (
    Array.from({
        length: (stop - start) / step + 1
    }, (_, i) => start + (i * step))
)

const refetchXsrfCookie =  async (error) =>  {
    error.config.retries = error.config.retries || {
        count: 0
    };
    const status = error.response ? error.response.status : null
    const { config } = error;
    if(status === 419 && error.config.retries.count < 3) {
        await fetch('/sanctum/csrf-cookie');
        error.config.retries.count += 1;
        return window.axios(config)
    }
    return Promise.reject(error);
};


export { range, refetchXsrfCookie }
